// ⚠ BAD CODE STYLE ⚠
// Please do not use $scope ❗
// Check /docs dir for more info.
import { loginPointLabel } from '../../../../components/sp-login-point/sp-login-point.enum';
import { loginTypeLabel } from '../../../../components/sp-login-type/sp-login-type.enum';

/** @ngInject */
export function Controller($scope, $state, CompanyLoginReportService, $filter, $translate, CompanyUser) {
    this.loginTypeLabel = loginTypeLabel;
    this.loginPointLabel = loginPointLabel;
    const self=this;
   
    $scope.displaySpinner = true;
    $scope.queryAppTypes="";
    $scope.displayedItems=[];
    $scope.hstep = 1;
    $scope.mstep = 1;
    $scope.loginTypesTranslated = [];
    self.singleSaaspassId=null;
    $scope.noAppSelected=null;
    $scope.boolFlag={successLogin: true, failLogin: true};
    const companyId = $state.params.companyId;
     CompanyLoginReportService.companyLoginReport.get({companyId : companyId}).$promise.then(function(data) {
         $scope.displaySpinner = false;
         $scope.reportData=data.reportData;
         for (var i = 0; i < $scope.reportData.length; i++) {
           $scope.reportData[i].loggedInOn =  new Date($scope.reportData[i].loggedInOn).toString().slice(4, 24);
         }
         $scope.filterData=data.filterData;
         $scope.filterData.applicationTypes=[];
         $scope.filterData.loginTypes=[];
         $scope.filterData.saaspassIDs=[];
         $scope.companyApplications=data.companyApplications;
         $scope.applicationTypes=data.applicationTypes;
         $scope.loginTypes=data.loginTypes;
         self.startDate=new Date($scope.filterData.startDate);
         self.endDate=new Date($scope.filterData.endDate);
         $scope.startTime=new Date($scope.filterData.endDate+' '+$scope.filterData.startTime);
         $scope.convertedDateTimeFrom  = new Date($scope.filterData.startDate+' '+$scope.filterData.startTime).toString();
     	 $scope.convertedDateTimeTo  = new Date($scope.filterData.endDate+' '+$scope.filterData.endTime).toString();
         $scope.datepickerOptions = {maxDate: new Date($scope.filterData.endDate) ,minDate:new Date(data.minDate) };
         }, function(error) {
             $scope.displaySpinner = false;
         });
    
    $scope.thumbnailUrl= function(appType) {
        var appTypeIndex=$scope.applicationTypes.findIndex((obj => obj.applicationTypeName == appType));
        var slug=$scope.applicationTypes[appTypeIndex].slug;
         return 'https://cdn.saaspass.com/apps/'+slug+'/images/thumb.png';
     }
    
    
    $scope.changeSelection = function(member) {
        var index=$scope.filterData.applicationTypes.indexOf(member);
        if( index==-1){
            $scope.filterData.applicationTypes.push(member);
        } else {
            $scope.filterData.applicationTypes.splice(index, 1);
        }
        
    }
    $scope.clearOldMessage = function () {
        $scope.message =null;
    }
    $scope.identifySaaspassUser= function() {
        $scope.message =null;
        CompanyUser.identifyCompanyUser({
            companyId : companyId,
            uid : encodeURIComponent(self.singleSaaspassId)
        }, function(data) {
            var member=data.saaspassUser.saaspassId;
            var index=$scope.filterData.saaspassIDs.indexOf(member);
            if( index==-1){
            $scope.filterData.saaspassIDs.push(member);
            }
        }, function(error) {
            
            if(error.status==404){
                $scope.message=$translate.instant('report_section.main.filters.search_saaspass_fail');
             } 
            else {
            $scope.message = error.data.message;}
        });
        self.singleSaaspassId=null;
    }

 $scope.convertTZ= function(date) {
	var currentLang = $translate.proposedLanguage() || $translate.use();
	
	//console.log(currentLang);
    return new Date( date).toLocaleString(currentLang, {timeZone: $scope.timeZoneOfUser}   );
}
$scope.getData = function (dData) {
       return  new Date(dData);
    }
    $scope.clearSaaspassList = function () {
        $scope.filterData.saaspassIDs = [];
    }
    $scope.clearAppTypesSelection = function () {
        $scope.filterData.applicationTypes=[];
    }
    $scope.clearLoginTypesSelection = function () {
        $scope.filterData.loginTypes=[];
        $scope.loginTypesTranslated=[];
    }
    $scope.changeStatusFilter=function(newValue,isSuccessFlag) {
        if(isSuccessFlag) $scope.boolFlag.successLogin=newValue; else  $scope.boolFlag.failLogin=newValue;
        if($scope.boolFlag.successLogin) {
            if($scope.boolFlag.failLogin) {
                $scope.filterData.status=null;
            } else {
                $scope.filterData.status=true;
            }
        } else {
            if($scope.boolFlag.failLogin) {
                $scope.filterData.status=false;
            } else {
                $scope.filterData.status=null;
            }
        }
    }
    
    $scope.changeSelectionLoginType = function(member) {
        const translatedMember = $translate.instant(loginTypeLabel(member));
        var index=$scope.filterData.loginTypes.indexOf(member);
        if( index==-1){
            $scope.filterData.loginTypes.push(member);
            $scope.loginTypesTranslated.push(translatedMember);
        } else {
            $scope.filterData.loginTypes.splice(index, 1);
            $scope.loginTypesTranslated.splice(index,1);
        }
        
    }
    $scope.close= function($event) {
        self.opened = false;
        self.opened1 = false;
    }
    $scope.open = function($event, type) {
        $event.preventDefault();
        $event.stopPropagation();
        self.opened1=false;
        self.opened=false;
        if (type == 1) {
            self.opened = true;
            self.opened1 = false;
        } else {
            self.opened1 = true;
            self.opened = false;
        }
    };
    $scope.applyFilter=function() {
        $scope.displaySpinner = true;
        $scope.filterData.startDate= $filter('date')(self.startDate, "yyyy-MM-dd"); 
        $scope.filterData.endDate= $filter('date')(self.endDate, "yyyy-MM-dd");
		$scope.timeZoneOfUser=Intl.DateTimeFormat().resolvedOptions().timeZone;//'UTC'+new Date().getTimezoneOffset()*60*(-1); 
        CompanyLoginReportService.companyLoginReportFilter.doFilter({companyId: companyId},$scope.filterData).$promise.then(function(data) {
            $scope.displaySpinner = false;
            $scope.reportData=data;
            for (var i = 0; i < $scope.reportData.length; i++) {
                $scope.reportData[i].loggedInOn =  new Date($scope.reportData[i].loggedInOn).toString().slice(4, 24);
            }
            $scope.displayedItems=data;

            }, function(error) {
                $scope.displaySpinner = false;
            });
        
    }
    $scope.changeDateTime = function() {
        $scope.convertedDateTimeFrom  = new Date($filter('date')(self.startDate, "yyyy-MM-dd")+' '+$scope.filterData.startTime).toString();
        $scope.convertedDateTimeTo  = new Date($filter('date')(self.endDate, "yyyy-MM-dd")+' '+$scope.filterData.endTime).toString();
    }
    
    $scope.export = {
            template: 'companystatistics',
            name: 'SAASPASS_Statistics',
            fields: ['username','saaspassId', 'displayName', 'loginType', 'loginIp','loginPoint', 'loginService', 'sucessfulLogin', 'loggedInOn']
        };
}


// WEBPACK FOOTER //
// ./src/portal/states/company/reports/company-login-report/company-login-report.controller.js